import * as T from '@/types'

export enum HttpMethod {
    GET = 'get',
    PUT = 'put',
    POST = 'post',
    PATCH = 'patch',
    DELETE = 'delete',
}

export enum ApiRequestType {
    FILES_GET = 'ApiRequestType.FILES_GET',
}

// Don't think this will be needed... 
// Was linked to Ibby implementation
export interface ApiRequestDefinition {
    httpMethod: T.HttpMethod
    getRoute: (params: any) => string
    requiredParams: string[]
}
